import OrganizationContentStack from '@/components/organization-content-stack';
import { Stack } from '@mui/material';
import CreateOverlay from '@/components/common/create-overlay';

export default function CreatePage() {
  return (
    <OrganizationContentStack
      content={
        <Stack direction="column" gap={2} sx={{ width: '100%' }}>
          <CreateOverlay />
        </Stack>
      }
    />
  );
}
